'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export function ClientRedirector({ toUrl }: { toUrl: string }) {
  const router = useRouter();

  useEffect(() => {
    // Perform client-side redirect to the interactive map page
    router.replace(toUrl);
  }, [toUrl, router]);

  return null;
}
